import { db } from "@/firebase";
import {
  doc,
  getDoc,
  deleteDoc,
  updateDoc,
  // collection,
  arrayRemove,
  arrayUnion,
  // getDocs,
  // query,
  // where,
  // limit,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";
import router from "@/router";
const workspace = {
  state: {
    brand: null,
    branding: null,
    brands: [],
    workspace: null,
    workspaces: [],
  },
  mutations: {
    setWorkspace(state, val) {
      state.workspace = val;
    },
    setWorkspaces(state, val) {
      state.workspaces = val;
    },
    setKeywords(state, val) {
      state.workspace.about.keywords = val;
    },
    removeInvite(state, val) {
      let index = state.workspace.invites.findIndex((i) => i === val);
      state.workspace.invites.splice(index, 1);
    },
    updateWorkspace(state, val) {
      if (val.type.includes(".")) {
        state.workspace[val.type.split(".")[0]][val.type.split(".")[1]] =
          val.value;
      } else {
        state.workspace[val.type] = val.value;
      }
      console.log(state);
    },
    setBrands(state, val) {
      state.brands = val;
    },
    setBrand(state, val) {
      state.brand = val;
    },
    setBranding(state, val) {
      state.branding = val;
    },
    removeUser(state, val) {
      let i = state.workspace.members.findIndex((m) => m.uid === val.uid);
      state.workspace.members.splice(i, 1);
    },
  },
  actions: {
    async removeInvite({ state, commit }, item) {
      const removeInvite = httpsCallable(functions, "removeInvite");

      const res = await removeInvite({
        invite: item,
        workspace: state.workspace.uid,
      });
      console.log(res.data);
      commit("removeInvite", item);
      commit("setNotification", {
        show: true,
        text:
          res.data === 200
            ? `Invite removed!`
            : "Something went wrong, try again later.",
        type: res.data === 200 ? "primary" : "error",
      });
    },

    async updateWorkspace({ commit, state }, val) {
      commit("updateWorkspace", val);
      const ref = doc(db, "workspaces", state.workspace.uid);
      let value = val.value;
      if (val.type.includes("brand.logo_") && value) {
        value = val.value.uid;
      }
      try {
        await updateDoc(ref, {
          [val.type]: value,
        });
        commit("setNotification", {
          show: true,
          text: "Workspace updated!",
          type: "primary",
          icon: "",
        });
      } catch (error) {
        console.log(error);
        commit("setNotification", {
          show: true,
          text: "Error updating workspace!",
          type: "error",
          icon: "",
        });
      }
    },
    async addKeyword({ commit, state }, val) {
      let list = state.workspace.about.keywords;
      list.push(val);
      commit("setKeywords", list);

      const ref = doc(db, "workspaces", state.workspace.uid);
      await updateDoc(ref, {
        "about.keywords": arrayUnion(val),
      });

      commit("setNotification", {
        show: true,
        text: "Keyword added!",
        type: "primary",
        icon: "",
      });
    },
    async removeKeyword({ commit, state }, val) {
      let list = state.workspace.about.keywords;
      let index = list.findIndex((k) => k === val);
      list.splice(index, 1);
      commit("setKeywords", list);
      console.log(val);
      const ref = doc(db, "workspaces", state.workspace.uid);
      await updateDoc(ref, {
        "about.keywords": arrayRemove(val),
      });

      commit("setNotification", {
        show: true,
        text: "Keyword removed!",
        type: "primary",
        icon: "",
      });
    },
    async fetchWorkspace({ commit, rootState }) {
      commit("setLoading", { type: "workspace", val: true });
      let current_workspace = null;
      let workspaces = [];
      let workspaces_list =
        rootState.users.userProfile.email === "max@stix.social"
          ? rootState.admin.workspaces.map((w) => w.uid)
          : rootState.users.userProfile.workspaces;
      await Promise.all(
        workspaces_list.map(async (w) => {
          let ws = null;

          const docRef = doc(db, "workspaces", w);
          const workspace = await getDoc(docRef);

          ws = workspace.data();

          const getWorkspaceSubscription = httpsCallable(
            functions,
            "getWorkspaceSubscription",
          );
          const res = await getWorkspaceSubscription({
            workspace: w,
          });

          ws.subscription = res.data;

          if (w === rootState.users.userProfile.workspace) {
            ws.members.map(async (m, i) => {
              let member = m;

              const docRef = doc(db, "users", m.uid);
              const docSnap = await getDoc(docRef);

              member.name = docSnap.data().name;
              member.email = docSnap.data().email;
              ws.members[i] = member;

              if (
                m.uid === rootState.users.userProfile?.uid &&
                w === rootState.users.userProfile?.workspace
              ) {
                commit("setUserRole", member.role);
              }
            });

            if (ws.brand) {
              commit("setBrand", ws.brand);

              if (ws.brand.logo_light) {
                const docSnapL = await getDoc(
                  doc(db, "workspaces", ws.uid, "brand", ws.brand.logo_light),
                );

                if (docSnapL.exists()) {
                  ws.brand.logo_light = docSnapL.data();
                }
              }

              if (ws.brand.logo_dark) {
                const docSnapD = await getDoc(
                  doc(db, "workspaces", ws.uid, "brand", ws.brand.logo_dark),
                );

                if (docSnapD.exists()) {
                  ws.brand.logo_dark = docSnapD.data();
                }
              }
            }

            if (ws.branding) {
              commit("setBranding", ws.branding);
            }
          }
          workspaces.push(ws);
          if (rootState.users.userProfile.workspace === w) {
            current_workspace = ws;
          }
        }),
      );
      console.log("current_workspace?.subscription", current_workspace);
      if (
        current_workspace?.subscription?.status !== "active" &&
        !rootState.users.userProfile.subscription.trial
      ) {
        router.push("/subscription");

        if (rootState.users.userProfile.subscription.active) {
          commit("setNotification", {
            show: true,
            text: "You have an active subscription, but this workspace is not activated yet. Add your workspace to your subscription to continue.",
            type: "primary",
            icon: "",
          });
        } else {
          commit("setNotification", {
            show: true,
            text: "Your workspace is not active. Please upgrade with a subscription to continue.",
            type: "primary",
            icon: "",
          });
        }
      }
      commit("setWorkspace", current_workspace);
      commit("setWorkspaces", workspaces);
      commit("setLoading", { type: "workspace", val: false });
    },
    async changeWorkspace({ dispatch, rootState }, uid) {
      if (uid == rootState.users.userProfile.workspace) {
        return;
      }
      await updateDoc(doc(db, "users", rootState.users.userProfile.uid), {
        workspace: uid,
      });

      const auth = getAuth();
      const user = auth.currentUser;
      dispatch("fetchUserProfile", user);
    },
    async deleteWorkspace({ dispatch, rootState }, uid) {
      return new Promise((resolve, reject) => {
        (async () => {
          try {
            const docRef = doc(db, "workspaces", uid);
            const workspace = await getDoc(docRef);
            let allowed =
              workspace
                .data()
                .members.find((u) => u.uid === rootState.users.userProfile.uid)
                .role === "admin";
            if (!allowed) {
              reject();
            } else {
              let newWorkspace = rootState.users.userProfile.workspaces.find(
                (w) => w != uid,
              );
              await updateDoc(
                doc(db, "users", rootState.users.userProfile.uid),
                {
                  workspaces: arrayRemove(uid),
                  workspace: newWorkspace != undefined ? newWorkspace : null,
                },
              );

              await deleteDoc(doc(db, "workspaces", uid));

              const auth = getAuth();
              const user = auth.currentUser;
              dispatch("fetchUserProfile", user);
              resolve();
            }
          } catch (error) {
            reject(error); // Handle errors
          }
        })();
      });
    },
    async createWorkspace({ commit, dispatch }, data) {
      commit("setLoading", { type: "general", val: true });

      const createWorkspace = httpsCallable(functions, "createWorkspace");
      const res = await createWorkspace(data);
      console.log(res.data);

      const auth = getAuth();
      const user = auth.currentUser;
      dispatch("fetchUserProfile", user);

      return 200;
    },
    async removeUser({ commit, state }, val) {
      const removeUser = httpsCallable(functions, "removeUser");
      const res = await removeUser({
        uid: val.uid,
        workspace: state.workspace.uid,
      });
      console.log(res);
      commit("removeUser", val);
      commit("setNotification", {
        show: true,
        text: "User removed!",
        type: "primary",
        icon: "",
      });
    },
  },
  getters: {},
};

export default workspace;
